/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Commission_LeadInputs */

const es_landing_commission_lead = /** @type {(inputs: Landing_Commission_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión plana (+IVA), y solo cuando alquilas. Sin reservas, no pagas nada. `)
};

const gl_landing_commission_lead = /** @type {(inputs: Landing_Commission_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión plana (+IVE), e só cando alugas. Sen reservas, non pagas nada. `)
};

const en_landing_commission_lead = /** @type {(inputs: Landing_Commission_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flat commission (+VAT), and only when you rent out. No bookings, no fees. `)
};

/**
* | output |
* | --- |
* | "Flat commission (+VAT), and only when you rent out. No bookings, no fees." |
*
* @param {Landing_Commission_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_commission_lead = /** @type {((inputs?: Landing_Commission_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Commission_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_commission_lead(inputs)
	if (locale === "en") return en_landing_commission_lead(inputs)
	return es_landing_commission_lead(inputs)
});